import { Typography } from '@breetometer/components';
import { Amount, RowSection } from 'BreetComponents';
import { type CURRENCYCODETYPE, CURRENCYCONFIG, formatDateTime, getSafeObjectField } from 'BreetHelpers';
import { useCurrencyOutput } from 'BreetHooks';

import type { IEditProps } from '../DialogWithdrawalHistoryDetails.helpers';
import RowBalance from './RowBalance';
import RowStatusNote from './RowStatusNote';

const Edits = ({ withdrawalHistoryData }: IEditProps) => {
	const currencyOutput = useCurrencyOutput();

	const fiatConfig = getSafeObjectField(
		CURRENCYCONFIG,
		withdrawalHistoryData.currency.toUpperCase() as CURRENCYCODETYPE,
		CURRENCYCONFIG.USD
	);

	return (
		<>
			<div className='transactiondetails_header'>
				<Typography as='p'>ADMIN {withdrawalHistoryData.isCredit ? 'CREDIT' : 'DEBIT'}</Typography>
				<Typography as='h5'>
					{fiatConfig.symbol}
					<Amount>{currencyOutput(withdrawalHistoryData.amount)}</Amount>
				</Typography>
			</div>

			<div className='transactiondetails_itemscontainer bg-primary-500'>
				<RowSection.Single
					label='Date'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>{formatDateTime(withdrawalHistoryData.updatedAt)}</Typography>
						</div>
					}
				/>

				<RowStatusNote
					status={withdrawalHistoryData.status}
					note={withdrawalHistoryData.doc.reason}
				/>

				<RowBalance
					symbol={fiatConfig.symbol}
					before={currencyOutput(withdrawalHistoryData.doc.balanceBefore)}
					after={currencyOutput(withdrawalHistoryData.doc.balanceAfter)}
				/>
			</div>
		</>
	);
};

export default Edits;
